import { render } from "./Object.vue?vue&type=template&id=11b3b0e3&scoped=true"
import script from "./Object.vue?vue&type=script&lang=js"
export * from "./Object.vue?vue&type=script&lang=js"

import "./Object.vue?vue&type=style&index=0&id=11b3b0e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b3b0e3"]])

export default __exports__